<template>
  <el-dialog
    title="结算详情"
    :visible="!!record"
    @open="onOpen"
    @close="onClose"
    width="1200px"
  >
    <div class="page-actions"></div>
    <el-table :data="list">
      <el-table-column prop="lockUserId" label="锁仓用户ID"></el-table-column>
      <el-table-column prop="lockAmount" label="锁仓数量">
        <template slot-scope="scope">
          {{ Number(scope.row.lockAmount) }}
        </template>
      </el-table-column>
      <el-table-column prop="lockRecordId" label="锁仓记录ID">
        <template slot-scope="scope">
          <div
            class="link"
            target="_blank"
            @click="open(scope.row.lockRecordId)"
          >
            {{ scope.row.lockRecordId }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="leagueId" label="门派ID"></el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.type === 'LEAGUE_ANNUAL'"
            >锁仓利息</el-tag
          >
          <el-tag type="danger" v-if="scope.row.type === 'LEAGUE_BONUS'"
            >锁仓分红</el-tag
          >
          <el-tag type="info" v-if="scope.row.type === 'LEAGUE_INVITE_PROFIT'"
            >推荐人奖励</el-tag
          >
          <el-tag type="default" v-if="scope.row.type === 'LEAGUE_OWNER_PROFIT'"
            >掌门奖励</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="奖励数量"></el-table-column>
      <!-- <el-table-column prop="coinType" label="币种"></el-table-column> -->
      <el-table-column prop="transactionTime" label="结算时间">
        <template slot-scope="scope">
          {{ scope.row.transactionTime | moment }}
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </el-dialog>
</template>

<script>
import './store';
import { mapState, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'leagueSettleRecordDetail',
  data() {
    return {
      filter: {}
    };
  },
  props: ['record'],
  components: {
    Pagination
  },
  computed: {
    ...mapState('leagueSettleRecordDetail', [
      'list',
      'pagination',
      'totalCount'
    ])
  },
  methods: {
    ...mapActions('leagueSettleRecordDetail', ['getList']),
    ...mapMutations('leagueSettleRecordDetail', ['setPagination']),
    getRecords(data = {}) {
      this.getList({
        ...this.pagination,
        ...this.filter,
        ...data,
        userId: this.record.userId,
        type: this.record.type,
        coinType: this.record.coinType,
        settleId: this.record.settleId
      });
    },
    open(id) {
      window.open('#/home/league/records?id=' + id, 'abc');
    },
    onOpen() {
      if (!this.record) return;
      this.getRecords();
    },
    onClose() {
      this.setPagination({
        ...this.pagination,
        page: 1
      });
      this.$emit('close');
    },
    handleCurrentChange(pagination) {
      this.getRecords(pagination);
    }
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
.link {
  text-decoration: underline;
  cursor: pointer;
}
</style>
